
export default {
  name: 'MethodHeader',
  props: {
    paymentMethod: {
      type: Object,
      required: true,
    },
  },
};
